import React  from 'react';
import { ChromePicker, ColorResult } from 'react-color';
import cx from 'classnames';
import styles from './ColorPicker.module.css';

type ColorPickerProps = {
    property: string
    value: string
    onChange: (property: string, value: string) => void
    classes?: string
    children?: React.ReactNode
};

const ColorPicker: React.FC<ColorPickerProps> = ({
    property,
    value = '#fc0',
    onChange,
    classes,
    children
}) => {
    const handleColorChange = (color: ColorResult) => {
        onChange(property, color.hex);
    };

    return (
        <div className={cx(styles['color-picker-container'], classes)}>
            <div style={{color: '#555', fontSize: '0.75rem'}}>{children}</div>
            <ChromePicker disableAlpha={true} color={value} onChange={handleColorChange} />
        </div>
    );
};

export default ColorPicker;
